import React, { useImperativeHandle, useRef } from "react";
import { Button, Selector } from "../Elements";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Checkbox } from "../Elements";
import commonNetwork from "../../../common/api/commonNetwork";
import MaterailTable from "../Elements/MaterialTable";
import InstallmentDetailModal from "./InstallmentDetailModal";
import { formatCurrency } from "../../../lib/helpers";
import { getStatusClass } from "../Elements/StatusBox";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getVPList } from "../../../store/slices/vpListSlice";
import ConfirmationModal from "../ConfirmationModal";
import { FaEllipsisV } from "react-icons/fa";
import { ListItemIcon, Menu, MenuItem, } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { getNavigationUrl } from "../../../common/helpers/navigationHelpers";
import { errorMessages } from "../../../constants/messages/errorMessages";
import { muiMenuStyles } from "../../../constants/muiMenuStyles";
import CommissionHtmlTableButton from "../VirtualPos/CommissionHtmlTableButton";

type InstallmentCardProp = {
    vpId: number,
    bankId: number,
    isinstallment: Boolean,
    isPf: Boolean,
    isInstallmentLoading: Boolean,
    allBrandWithInstallment: Array,
    setAllBrandWithInstallment: Function,
    selectedCardBrand: AnyAction,
    setSelectedCardBrand: Function,
    isInstallmentApplyToAll: Boolean,
    setIsInstallmentApplyToAll: Function,
    posDetailVpName: String,
    isCheckCommission: Boolean,
    isPosActive: Boolean,
};

const InstallmentCard = React.forwardRef((props: InstallmentCardProp, ref) => {
    const classes = muiMenuStyles();

    useImperativeHandle(ref, () => ({

        getInstallmentOnPost() {
            return getInstallmentOnPost();
        }
    }));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const goToPosConnectionSettings = getNavigationUrl("/pos-baglanti-ayarlari");

    const navbarState = useSelector((state) => state.navbar);
    const sideBarOpen = navbarState.isOpen;
    const tableRef = useRef();
    const confirmModalRef = useRef();
    const installmentEditModalRef = useRef();
    const { vpId, isinstallment, isPf, allBrandWithInstallment, isInstallmentLoading,
        selectedCardBrand, setAllBrandWithInstallment, setSelectedCardBrand,
        isInstallmentApplyToAll, setIsInstallmentApplyToAll, posDetailVpName, isCheckCommission,
        isPosActive } = props;

    const [postLoading, setPostLoading] = useState(false);
    const [installmentParameters, setInstallmentParameters] = useState({
        isMinAmount: false,
        minAmount: 0,
        isOwnInstallment: isPf != null ? isPf : false,
        isShowInstallment: false,
    });
    const [anchorEl, setAnchorEl] = React.useState(null);
    const isopenMenu = Boolean(anchorEl);
    const [dropdownAllValues, setDropdownAllValues] = useState({});

    const saveInstallmentrev = () => {

        if (isInstallmentApplyToAll) {
            var parsedBrands = JSON.parse(JSON.stringify(allBrandWithInstallment));
            var brandIndex = allBrandWithInstallment.findIndex(w => w.bankBrand.brandId == selectedCardBrand?.brandId);
            var brandInstallments = allBrandWithInstallment[brandIndex].installmentList;
            for (let i = 0; i < parsedBrands.length; i++) {
                parsedBrands[i].installmentList = brandInstallments;
            }
            saveInstallments(parsedBrands);
        } else {
            saveInstallments(allBrandWithInstallment);
        }
    }

    const saveInstallments = async (allInstallments) => {
        try {
            setPostLoading(true);
            allInstallments.forEach(item => {
                item.installmentList.forEach(installment => {
                    const isBusiness = installment.hasOwnProperty('isBusiness') ? installment.isBusiness : null;
                    const isIndividual = installment.hasOwnProperty('isIndividual') ? installment.isIndividual : null;

                    if ((isBusiness === null && isIndividual === null) || (isBusiness === false && isIndividual === false)) {
                        installment.isBusiness = true;
                        installment.isIndividual = true;
                    }
                });
            });

            var url = "/installment/save-with-brands";
            var params = {
                VpId: vpId,
                VpInstallment: allInstallments,
                isApplyToAll: isInstallmentApplyToAll
            }

            const { isSuccess, errorMessage } = await commonNetwork.post(url, params);
            if (isSuccess) {
                dispatch(getVPList());
                toast.success("Taksit ayarları başarılı bir şekilde kaydedilmiştir.");

                navigate(goToPosConnectionSettings);
            } else {
                toast.error(errorMessage);
            }
        } catch (error) {

            toast.error(errorMessages.anError);
        } finally {
            setPostLoading(false);
        }
    };

    const getInstallmentOnPost = () => {
        return {
            installmentParameters,
            allBrandWithInstallment,
            isInstallmentApplyToAll
        }
    }

    const onChangeBrand = (key) => {
        var brandIndex = allBrandWithInstallment.findIndex(w => w.bankBrand.brandId == key);

        setSelectedCardBrand(allBrandWithInstallment[brandIndex].bankBrand);
    }

    const deleteInstallmentClick = (item) => {
        confirmModalRef.current.showConfirm({
            title: "Uyarı!",
            contentText: "Taksit silinecek. Onaylıyor musunuz?",
            confirmText: "Onayla",
            cancelText: "İptal",
            confirmCallBack: () => deleteInstallmentConfirm(item)
        });
    }

    const deleteInstallmentConfirm = (item) => {
        var parsedBrands = JSON.parse(JSON.stringify(allBrandWithInstallment));
        var brandIndex = allBrandWithInstallment.findIndex(w => w.bankBrand.brandId == selectedCardBrand?.brandId);
        var brandInstallments = allBrandWithInstallment[brandIndex].installmentList;

        var itemIndex = brandInstallments.findIndex(w => w.installment == item.installment);
        if (!parsedBrands[brandIndex].deletedInstallmentList) {
            parsedBrands[brandIndex].deletedInstallmentList = [];
        }
        parsedBrands[brandIndex].deletedInstallmentList.push(brandInstallments[itemIndex]);
        parsedBrands[brandIndex].installmentList.splice(itemIndex, 1);

        setAllBrandWithInstallment(parsedBrands);

    }
    const editInstallmentClick = (row) => {
        installmentEditModalRef.current.openModal(row);
    }
    const onUpdateAllValues = (values) => {
        setInstallmentAllElement(values);

    }

    const getLastInstallment = () => {
        var brandIndex = allBrandWithInstallment.findIndex(w => w.bankBrand.brandId == selectedCardBrand?.brandId);

        if (brandIndex != -1) {
            var brandInstallments = allBrandWithInstallment[brandIndex].installmentList;
            return brandInstallments[brandInstallments.length - 1].installment;

        } else {
            return 1;
        }
    }

    const addInstallmentClick = () => {
        var parsedBrands = JSON.parse(JSON.stringify(allBrandWithInstallment));
        var brandIndex = allBrandWithInstallment.findIndex(w => w.bankBrand.brandId == selectedCardBrand?.brandId);

        if (brandIndex != -1) {
            var brandInstallments = allBrandWithInstallment[brandIndex].installmentList;

            var newInstallments = JSON.parse(JSON.stringify(brandInstallments));
            if (newInstallments.length <= 36) {
                var generatedInstallment = {
                    "installment": getLastInstallment() + 1,
                    "valorDate": 0,
                    "commissionAmount": 0,
                    "status": false,
                }
                newInstallments.push(generatedInstallment);
            }
            parsedBrands[brandIndex].installmentList = newInstallments;

            setAllBrandWithInstallment(parsedBrands);
        }
    }

    function getAllBrandSelectList() {
        const options = [];
        for (let i = 0; i < allBrandWithInstallment.length; i++) {
            const element = allBrandWithInstallment[i].bankBrand;
            options.push(
                {
                    value: element.brandId,
                    label: element.brandName,
                }
            );

        }
        return options;
    }

    function getSelectedBrandInstallments() {
        var brandIndex = allBrandWithInstallment.findIndex(w => w.bankBrand.brandId == selectedCardBrand?.brandId);

        if (brandIndex != -1) {
            var brandInstallments = allBrandWithInstallment[brandIndex].installmentList;
            return brandInstallments;
        } else {
            return null
        }
    }
    const setInstallmentElement = (installmentItem, name, value) => {

        var parsedBrands = JSON.parse(JSON.stringify(allBrandWithInstallment));
        var brandIndex = allBrandWithInstallment.findIndex(w => w.bankBrand.brandId == selectedCardBrand?.brandId);

        if (isInstallmentApplyToAll) {

            for (let i = 0; i < parsedBrands.length; i++) {

                var brandInstallments = allBrandWithInstallment[i].installmentList;
                var itemIndex = brandInstallments.findIndex(w => w.installment == installmentItem.installment);
                var newInstallments = JSON.parse(JSON.stringify(brandInstallments));
                newInstallments[itemIndex][name] = value;
                parsedBrands[i].installmentList = newInstallments;

                setAllBrandWithInstallment(parsedBrands);
            }
        } else {
            if (brandIndex != -1) {
                var brandInstallments = allBrandWithInstallment[brandIndex].installmentList;
                var itemIndex = brandInstallments.findIndex(w => w.installment == installmentItem.installment);
                var newInstallments = JSON.parse(JSON.stringify(brandInstallments));
                newInstallments[itemIndex][name] = value;
                parsedBrands[brandIndex].installmentList = newInstallments;

                setAllBrandWithInstallment(parsedBrands);
            }
        }
    }

    const setInstallmentAllElement = (installmentItem) => {
        var parsedBrands = JSON.parse(JSON.stringify(allBrandWithInstallment));
        var brandIndex = allBrandWithInstallment.findIndex(w => w.bankBrand.brandId == selectedCardBrand?.brandId);
        if (isInstallmentApplyToAll) {

            for (let i = 0; i < parsedBrands.length; i++) {

                var brandInstallments = allBrandWithInstallment[i].installmentList;

                var itemIndex = brandInstallments.findIndex(w => w.installment == installmentItem.installment);
                var newInstallments = JSON.parse(JSON.stringify(brandInstallments));
                newInstallments[itemIndex] = installmentItem;
                parsedBrands[i].installmentList = newInstallments;

                setAllBrandWithInstallment(parsedBrands);
            }
        } else {
            if (brandIndex != -1) {
                var brandInstallments = allBrandWithInstallment[brandIndex].installmentList;

                var itemIndex = brandInstallments.findIndex(w => w.installment == installmentItem.installment);
                var newInstallments = JSON.parse(JSON.stringify(brandInstallments));
                newInstallments[itemIndex] = installmentItem;
                parsedBrands[brandIndex].installmentList = newInstallments;

                setAllBrandWithInstallment(parsedBrands);
            }
        }
    }
    const getLimitRow = ({ lowLimit, UpLimit, isSmallText, headerText, headerStatusClass }) => {
        var resultText = "";
        if (lowLimit > 0 && UpLimit > 0) {
            resultText = `Alt Limit:  ${formatCurrency(lowLimit)} \nÜst Limit:  ${formatCurrency(UpLimit)}`;
        } else if (lowLimit > 0) {
            resultText = `Alt Limit:  ${formatCurrency(lowLimit)}`;

        } else if (UpLimit > 0) {
            resultText = `Üst Limit:  ${formatCurrency(UpLimit)}`;
        }

        var headerHtml = "";
        if (headerText && headerText.length > 0) {
            headerHtml = `
             <div class="text-center  " title="${resultText}">
              <div class="text-center ${getStatusClass(headerStatusClass).className}">
                ${headerText}
              </div>
             </div>
            `;
        }
        return headerHtml;
    }

    const getExtraInstallmentRow = (item) => {
        var resultText = "";
        if (item.extraInstallmentCount > 0) {

            resultText = getLimitRow({
                headerStatusClass: "success",
                headerText: `+ ${item.extraInstallmentCount} Taksit`,
                isSmallText: true,
                lowLimit: item.extraInstallmentLowLimit,
                UpLimit: item.extraInstallmentUpLimit
            });
        }
        return (
            <div dangerouslySetInnerHTML={{
                __html: resultText
            }}>

            </div>
        );
    }

    const getInstallmentLimitRow = (item) => {
        var resultText = "";
        if (item.lowerLimit > 0 || item.upperLimit > 0) {
            resultText = ` 
            <div class="flex justify-between ">
           <div class="text-sm font-medium"> Alt Limit: </div>
              ${formatCurrency(item.lowerLimit)}
            </div> 
            <div class="flex justify-between ">
            <div class="text-sm font-medium">Üst Limit: </div>
              ${formatCurrency(item.upperLimit)} 
            </div> 
            `;
        }
        return (
            <div dangerouslySetInnerHTML={{
                __html: ` ${resultText} `
            }}>

            </div>
        );
    }

    const getInstallmentDeferralRow = (item) => {
        var resultText = "";
        if (item.deferralCount > 0) {
            resultText = getLimitRow({
                headerStatusClass: "primary",
                headerText: `${item.deferralCount} Ay Erteleme`,
                isSmallText: true,
                lowLimit: item.deferralLowLimit,
                UpLimit: item.deferralUpLimit
            });
        }
        return (
            <div dangerouslySetInnerHTML={{
                __html: resultText
            }}>

            </div>
        );
    }
    const handleClickMenu = (event, row) => {
        setDropdownAllValues(row);
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const installmentList = getSelectedBrandInstallments();

    const allBrandForSelect = getAllBrandSelectList();

    if (!isinstallment) {
        return null
    }

    const lastInstallment = getLastInstallment();

    const DropdownMenu = () => {
        return (
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={isopenMenu}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                classes={{
                    paper: classes.paper,
                }}
            >

                <MenuItem onClick={() => {
                    setAnchorEl(null);
                    editInstallmentClick(dropdownAllValues);
                }}>
                    <ListItemIcon>
                        <Edit fontSize="small" />
                    </ListItemIcon>
                    Düzenle
                </MenuItem>

                {lastInstallment == dropdownAllValues.installment ? (

                    <MenuItem onClick={() => {
                        setAnchorEl(null);
                        deleteInstallmentClick(dropdownAllValues)
                    }}>
                        <ListItemIcon>
                            <Delete fontSize="small" />
                        </ListItemIcon>
                        Sil
                    </MenuItem>
                ) : null}
            </Menu>
        );
    }

    return (
        <div>
            <ConfirmationModal ref={confirmModalRef}></ConfirmationModal>
            <InstallmentDetailModal ref={installmentEditModalRef} updateCallBack={onUpdateAllValues} />
            <div className="m-4 mb-4 pb-10 p-4 bg-white shadow-md rounded-md  !mb-20">
                <div className="flex flex-row items-center mt-4 sm:mt-4   ">
                    <h1 className="font-bold text-contrast-90">
                        Taksit ve Komisyon Ayarları
                    </h1>
                    <span className="ml-2 text-contrast-50 text-md ">
                        {"(" + posDetailVpName + ")"}
                    </span>
                </div>
                {allBrandForSelect.length > 1 ? (
                    <div className=" mt-4 sm:mt-4 px-8 sm:px-4  flex flex-row items-center w-full">
                        <Selector
                            options={allBrandForSelect}
                            name={`sendtype`}
                            defaultValue={allBrandForSelect.find(w => w.value == selectedCardBrand?.brandId)}
                            className=" w-[250px]"
                            label="Kart Programı"
                            isDisabled={isInstallmentApplyToAll}
                            onChange={({ value }) => onChangeBrand(value)}
                        />
                        <div className="mt-3">
                            <Checkbox
                                label={"Tüm Kart Programlarına Aynı Ayarlar Uygulansın"}
                                type="checkbox"
                                onChange={(ev) => setIsInstallmentApplyToAll(!isInstallmentApplyToAll)}
                                checked={isInstallmentApplyToAll}
                                className="ml-2  flex items-center"
                                id={"isInstallmentApplyToAll"}
                            />
                        </div>
                        {isCheckCommission && isPosActive &&
                            <div className="ml-3">
                                <CommissionHtmlTableButton vpId={vpId} />
                            </div>
                        }
                    </div>
                ) : null}

                <div className="mt-4 w-full">

                    <div className="flex flex-col space-y-2 w-full">

                        <MaterailTable
                            isLoading={isInstallmentLoading}
                            emptyMessage={isInstallmentLoading ? "Yükleniyor.." : " "}
                            ref={tableRef}
                            tableStyle={{
                                overflow: "hidden"
                            }}
                            isDisablePaging={true}
                            disableShadow={true}
                            className="p-2-i m-2-i"
                            bottomElement={installmentList?.length < 36 ? <div className="flex items-start justify-start">
                                <Button size="xl" color="gray" callback={addInstallmentClick} type="button">
                                    Taksit Ekle
                                </Button>
                            </div> : null
                            }
                            headerCells={[
                                {
                                    id: 'operations',
                                    numeric: false,
                                    label: 'İşlemler',
                                    exceptToExcel: true,
                                    disablePadding: true,
                                    isRender: true,
                                    disableSortIcon: true,
                                    className: "w-[60px]",
                                    renderRow: (row) => {

                                        return (
                                            <div className="flex flex-row justify-around items-center">

                                                <a id="basic-button"
                                                    aria-controls={isopenMenu ? 'basic-menu' : undefined}
                                                    aria-haspopup="true"
                                                    aria-expanded={isopenMenu ? 'true' : undefined}
                                                    className="cursor-pointer"
                                                    onClick={(event) => handleClickMenu(event, row)}>
                                                    <FaEllipsisV
                                                        className="block sm:block ml-2 h-3 w-3 font-light"

                                                    />
                                                </a>
                                                <DropdownMenu row={row}>

                                                </DropdownMenu>

                                            </div>
                                        );

                                    }
                                },
                                {
                                    id: "installment",
                                    isprimary: true,
                                    hide: true
                                },
                                {
                                    label: "Taksit",
                                    isRender: true,
                                    className: "w-[100px]",
                                    hideSortIcon: true,
                                    renderRow: (item) => (
                                        <>
                                            <div className="my-4 flex flex-row justify-start col-span-2 ">
                                                <Checkbox
                                                    label={item.installment == 1 ? "Peşin" : item.installment + " Taksit"}
                                                    type="checkbox"
                                                    onChange={(ev) => setInstallmentElement(item, "status", ev.target.checked)}
                                                    checked={item.status}
                                                    className="mr-2" Komisyon Oranı
                                                    id={item.installment + "status"}
                                                />
                                            </div>
                                        </>

                                    )
                                },
                                {
                                    id: "commissionAmount",
                                    label: "Komisyon Oranı",
                                    isRender: true,
                                    className: "w-[130px]",
                                    hideSortIcon: true,
                                    forcealign: "center",
                                    renderRow: (item) => (
                                        <div>
                                            {formatCurrency(item.commissionAmount, true)}
                                        </div>
                                    )
                                },
                                {
                                    label: "Hizmet Komisyon Oranı",
                                    id: "serviceCommissionRate",
                                    isRender: true,
                                    className: "w-[150px]",
                                    hideSortIcon: true,
                                    forcealign: "center",
                                    renderRow: (item) => (
                                        <div>
                                            {formatCurrency(item.serviceCommissionRate, true)}
                                        </div>
                                    )
                                },
                                {
                                    label: "Geri Ödeme Gün Sayısı",
                                    id: "valorDate",
                                    className: "w-[100px]",
                                    isRender: false,
                                    forcealign: "center",
                                    hideSortIcon: true,
                                },
                                {
                                    label: "Taksit Limiti",
                                    isRender: true,
                                    className: "max-w-[380px]",
                                    forcealign: "center",
                                    renderRow: (item) => getInstallmentLimitRow(item),
                                    hideSortIcon: true,
                                },
                                {
                                    label: "Artı Taksit",
                                    isRender: true,
                                    className: "max-w-[380px]",
                                    forcealign: "center",
                                    renderRow: (item) => getExtraInstallmentRow(item),
                                    hideSortIcon: true,
                                },
                                {
                                    label: "Taksit Erteleme",
                                    isRender: true,
                                    className: "max-w-[380px]",
                                    hideSortIcon: true,
                                    renderRow: (item) => getInstallmentDeferralRow(item)
                                },
                                {
                                    label: "Vade Günü Üst Limit",
                                    id: "termUpLimit",
                                    isRender: false,
                                    className: "max-w-[380px]",
                                    hideSortIcon: true,
                                    forcealign: "center",
                                },
                            ]}
                            tableData={installmentList || []}
                        >
                        </MaterailTable>
                    </div>
                </div>
            </div>

            <div className={`w-full  bottom-button-fixed ${sideBarOpen ? " openedmenu-width" : " closedmenu-width"}`} >
                <div className="  ml-0 flex flex-row justify-end bg-white shadow-md ">
                    <div className="m-4  p-0 space-x-4 flex flex-row">
                        <Button
                            size="lg"
                            color="gray"
                            hover="gray"
                            type="button"
                            callback={() => {
                                navigate(-1);
                            }}

                        >
                            Geri Dön
                        </Button>

                        <Button loading={postLoading}
                            callback={() => { saveInstallmentrev() }} size="lg" color="primary" hover="primary" type={"button"}
                            spanClass={"ml-1.5 mr-1.5"} >
                            Kaydet
                        </Button>
                    </div>
                </div>
            </div>
        </div>

    );
});
export default InstallmentCard;
